export function createElement(tag, className) {
  const element = document.createElement(tag);
  if (className) element.className = className;
  return element;
}

export function appendDefinitionList(container, div, details, title = null) {
  if (title) {
    const objectTitle = createElement("h4", "font-bold");
    objectTitle.innerText = title;
    container.appendChild(objectTitle);
  }

  const dl = createElement("dl", "grid grid-cols-[auto_1fr] gap-x-2 gap-y-1");

  details.forEach((detail) => {
    const separatorIndex = detail.indexOf(": ");
    if (separatorIndex === -1) return;

    const label = detail.slice(0, separatorIndex);
    const value = detail.slice(separatorIndex + 2);
    if (!label || !value) return;

    const dt = createElement("dt", "font-semibold");
    dt.innerText = label.trim();

    const dd = createElement("dd");
    dd.innerText = capitalizeFirstLetter(value.trim());

    dl.appendChild(dt);
    dl.appendChild(dd);
  });

  container.appendChild(dl);
  div.appendChild(container);
}

export function replacePlaceholders(template, data) {
  const getNestedValues = (object, path) => {
    return path.split(".").reduce((currentObject, key) => currentObject?.[key], object);
  };

  return template.replace(/\{([\w.]+)\}/g, (_, key) => {
    const value = getNestedValues(data, key);
    return value !== undefined && value !== null ? value : template;
  });
}

export function sanitizeQuestionTitle(survey, title) {
  if (title.includes("{loved_one_reference}")) {
    title = title.replace("{loved_one_reference}", survey.getValue("loved_one_reference"));
  }
  if (title.includes("{deceased_first_name}") && survey.getValue("deceased_first_name")) {
    title = title.replace("{deceased_first_name}", survey.getValue("deceased_first_name"));
  }
  if (title.includes("{was_is}")) {
    title = title.replace("{was_is}", survey.getValue("was_is"));
  }
  if (title.includes("{at_the_time_of_their_death}")) {
    title = title.replace("{at_the_time_of_their_death}", survey.getValue("at_the_time_of_their_death"));
  }
  if (title.includes("{was_is_capital}")) {
    title = title.replace("{was_is_capital}", survey.getValue("was_is_capital"));
  }
  if (title.includes("{did_does_capital}")) {
    title = title.replace("{did_does_capital}", survey.getValue("did_does_capital"));
  }

  return title;
}

export function addEditButton(survey, wrapperDiv, pageNumber, { isError = false } = {}) {
  const classesWhenError =
    "flex items-center justify-center gap-2 rounded-full font-bold w-fit duration-300 transition ease-in-out bg-amber-600 text-white px-3 py-2.5 hover:bg-amber-700";
  const classesDefault =
    "flex items-center justify-center gap-2 rounded-full font-bold w-fit duration-300 transition ease-in-out bg-mint-400 text-forest-600 px-3 py-2.5 hover:bg-mint-500 light:bg-navy-200 light:text-navy-600 light:hover:bg-navy-300";

  const editButton = createElement("button", isError ? classesWhenError : classesDefault);
  editButton.innerText = "Edit this section";
  editButton.addEventListener("click", () => {
    survey.currentPageNo = pageNumber;
  });

  const buttonWrapper = createElement("div", "flex justify-end");
  buttonWrapper.appendChild(editButton);
  wrapperDiv.appendChild(buttonWrapper);
}

export function transformString(string) {
  return string
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function reformatIfDateString(input) {
  const datePattern = /^\d{4}-\d{2}-\d{2}$/;

  if (datePattern.test(input)) {
    const parts = input.split("-");
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  }

  return input;
}
